import { render, staticRenderFns } from "./ServiceFive.vue?vue&type=template&id=778a4ed2&"
import script from "./ServiceFive.vue?vue&type=script&lang=js&"
export * from "./ServiceFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports